import { render } from "./manage-notification.vue?vue&type=template&id=30b370b1&scoped=true&ts=true"
import script from "./manage-notification.vue?vue&type=script&lang=ts"
export * from "./manage-notification.vue?vue&type=script&lang=ts"

import "./manage-notification.vue?vue&type=style&index=0&id=30b370b1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b370b1"]])

export default __exports__